import { trpc } from '../lib/trpc';
import { Button, Table } from '@mantine/core';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import { use } from 'react';
import { Link, useLocation } from 'wouter';

dayjs.extend(localizedFormat);

export const List = ({ modelId }: { readonly modelId: string }) => {
  const [, navigate] = useLocation();
  const documentList = use(
    trpc.documents.list.useQuery(
      { modelId },
      {
        experimental_prefetchInRender: true,
      },
    ).promise,
  );
  return (
    <>
      <Button
        component={Link}
        to={`/content/${modelId}/new`}
      >
        Add
      </Button>
      <div>
        <Table
          classNames={{
            td: 'py-2 border-b border-gray-300',
            tr: 'cursor-pointer hover:bg-gray-100',
          }}
          striped
        >
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Title</Table.Th>
              <Table.Th>Created at</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {documentList.map((document) => (
              <Table.Tr
                key={document.id}
                onClick={() => navigate(`/documents/${document.id}`)}
              >
                <Table.Td>{document.title}</Table.Td>
                <Table.Td>
                  {dayjs(document.createdAt).format('D MMM YYYY')}
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      </div>
    </>
  );
};
